import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'cahandcraft.editMode';

export const EditContext = createContext({
  editMode: false,
  toggleEditMode: () => {},
  openEditor: () => {},
  closeEditor: () => {},
  editing: null,
  configVersion: 0,
  bumpConfig: () => {},
});

export function EditProvider({ children }) {
  const [editMode, setEditMode] = useState(() => {
    try {
      return typeof window !== 'undefined' && window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  });
  const [editing, setEditing] = useState(null);
  const [configVersion, setConfigVersion] = useState(0);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, editMode ? '1' : '0');
    } catch (e) { /* ignore */ }
  }, [editMode]);

  const toggleEditMode = useCallback(() => {
    setEditMode((v) => !v);
    setEditing(null);
  }, []);
  const openEditor = useCallback((descriptor) => setEditing(descriptor || null), []);
  const closeEditor = useCallback(() => setEditing(null), []);
  const bumpConfig = useCallback(() => setConfigVersion((v) => v + 1), []);

  const value = useMemo(
    () => ({ editMode, toggleEditMode, openEditor, closeEditor, editing, configVersion, bumpConfig }),
    [editMode, toggleEditMode, openEditor, closeEditor, editing, configVersion, bumpConfig]
  );

  return <EditContext.Provider value={value}>{children}</EditContext.Provider>;
}
